const COOKIE = 'downloaded-file';

const Utils = {
    summarizeUploadFilesProgress: function (uploadFilesData) {
        const progress = {
            percentComplete: 0,
            totalLoaded: 0,
            totalSize: 0,
            uploadingFileCount: 0,
            completedFileCount: 0,
        };

        uploadFilesData.forEach((file) => {
            progress.totalLoaded += file.loaded;
            progress.totalSize += file.total;
            if (file.percentComplete === 100) {
                progress.completedFileCount++;
            } else if (file.percentComplete > -1) {
                progress.uploadingFileCount++;
            }
        });
        if (progress.totalSize > 0) {
            progress.percentComplete = Math.floor((100 * progress.totalLoaded) / progress.totalSize);
        }

        return progress;
    },

    isAscii: function (str) {
        for (let i = 0; i < str.length; i++) {
            const ch = str.charCodeAt(i);
            if (!(ch === 8 || ch === 10 || ch === 13 || (ch >= 32 && ch < 127))) {
                return false;
            }
        }
        return true;
    },

    getCookie: function (key) {
        var b = document.cookie.match('(^|;)\\s*' + key + '\\s*=\\s*([^;]+)');
        return b ? b.pop() : '';
    },

    deleteCookie: function (key) {
        document.cookie = key + '=; Max-Age=0; path=/; domain=' + document.location.hostname;
    },

    checkCookie: function (callback) {
        if (Utils.getCookie(COOKIE)) {
            Utils.deleteCookie(COOKIE);
            callback();
        } else {
            setTimeout(function () {
                Utils.checkCookie(callback);
            }, 1000);
        }
    },

    download: function (url, callback) {
        var element = document.createElement('a');
        element.setAttribute('href', url);
        element.setAttribute('download', 'filename');
        element.id = 'someid';
        element.style.display = 'none';
        document.body.appendChild(element);
        element.click();
        document.body.removeChild(element);

        if (callback) {
            Utils.deleteCookie(COOKIE);
            setTimeout(function () {
                Utils.checkCookie(callback);
            }, 1000);
        }
    },
};

function errorHandler(error) {
    /* eslint-disable-next-line no-console */
    console.error(error);
}

export { errorHandler, Utils };
